import { useContext } from 'react';
import { ImpersonateContext } from 'src/contexts/ImpersonateContext';

export default function useImpersonateContext() {
    return useContext(ImpersonateContext);
}